import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=61af10a8&scoped=true"
import script from "./GlobalLoading.vue?vue&type=script&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=61af10a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af10a8",
  null
  
)

export default component.exports